function getTimeRemaining(dateString) {
  const now = new Date();
  let targetDate;

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split('-').map(Number);
    targetDate = new Date(year, month - 1, day, 23, 59, 59);
  } else {
    targetDate = new Date(dateString);
  }

  const diffMs = targetDate - now;
  if (diffMs <= 0) return 'Expirado';

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(diffMinutes / (60 * 24));
  const hours = Math.floor((diffMinutes % (60 * 24)) / 60);
  const minutes = diffMinutes % 60;

  if (days > 0) return `${days} DIAS`;
  if (hours > 0 && minutes > 0) return `${hours}H ${minutes}M`;
  if (hours > 0) return `${hours}H`;
  return `${minutes}M`;
}

function updateTimeRemaining(container = document) {
  const elements = container.querySelectorAll('.js-time-remaining');
  elements.forEach((el) => {
    const dateStr = el.getAttribute('data-date');
    if (!dateStr) return;
    const display = getTimeRemaining(dateStr);
    if (display) el.textContent = display;
  });
}

export { updateTimeRemaining };